import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles({
  container: {
    paddingTop: '20px',
    paddingBottom: '20px',
    textAlign: 'right',
    width: '100%'
  },
  fullWidth: {
    maxWidth: '900px',
    margin: '0 auto'
  }
});

type MorningstarCopyrightProps = {
  fullCopyright?: boolean;
};

const MorningstarCopyright = ({
  fullCopyright = false
}: MorningstarCopyrightProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {fullCopyright ? (
        <div className={classes.fullWidth}>
          © {moment().format('YYYY')} Morningstar, Inc. All rights reserved.
          The information contained herein: (1) is proprietary to Morningstar
          and/or its content providers; (2) may not be copied or distributed;
          and (3) is not warranted to be accurate, complete, or timely. Neither
          Morningstar nor its content providers are responsible for any damages
          or losses arising from any use of this information.
        </div>
      ) : (
        <div>
          © Fintegrate. Data provided by © {moment().format('YYYY')}{' '}
          Morningstar, Inc.
        </div>
      )}
    </div>
  );
};

export default MorningstarCopyright;
